import { render } from "./GlobalOverlay.vue?vue&type=template&id=7b1a468d&scoped=true"
import script from "./GlobalOverlay.vue?vue&type=script&lang=js"
export * from "./GlobalOverlay.vue?vue&type=script&lang=js"

import "./GlobalOverlay.vue?vue&type=style&index=0&id=7b1a468d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1a468d"]])

export default __exports__